import React, { useCallback, useEffect, useState } from 'react';
import { Tabs, TabList, TabPanels, Tab } from '@chakra-ui/react';
import { GiTimeBomb } from 'react-icons/gi';
import { FiTrash2, FiArrowRight } from 'react-icons/fi';

import api from '../../services/api';
import { useAuth } from '../../hooks/auth';
import Sidebar from '../../components/Sidebar';
import Loading from '../../components/Loading';
import ModalHorarios from '../../components/Modal/ModalHorarios';
import ModalPausaProgramada from '../../components/Modal/ModalPausaProgramada';
import ModalPausaProgRemove from '../../components/Modal/ModalPausaProgRemove';
import Button from '../../components/Button';

import {
  Container,
  Content,
  Header,
  Horario,
  SemanaDias,
  DiaSemana,
  HorariosDia,
  Periodo,
  TabsView,
  TabHorarios,
  TabPausaProgramada,
  ListPausas,
  ItemPausa,
  Pausa,
  NenhumaPausa,
} from './styles';

interface HorarioDATA {
  abertura: string;
  dia: number;
  fechamento: string;
  fim: number;
  id: number;
  inicio: number;
  tempo: number;
}
interface DiaDATA {
  d_semana: string;
  dia: number;
  tempo: number;
}
interface ParadasDATA {
  cod_mes: number;
  mes: string;
  pausas: PausasDATA[];
}
interface PausasDATA {
  begin_event: string;
  begin_hora: string;
  end_envent: string;
  end_hora: string;
  id_event: number;
  mot_event: string;
  tempo: string;
  valor: string;
}

const Horarios: React.FC = () => {
  const { company, permissions } = useAuth();

  const [loading, setLoading] = useState(true);
  const [horarios, setHorarios] = useState<HorarioDATA[]>([]);
  const [semana, setSemana] = useState<DiaDATA[]>([]);
  const [paradas, setParadas] = useState<ParadasDATA[]>([]);

  const [tabIndex, setTabIndex] = useState(0);

  const [modalHorariosVisible, setModalHorariosVisible] = useState(false);
  const [diaModal, setDiaModal] = useState<DiaDATA>({} as DiaDATA);
  const [horarioModal, setHorarioModal] = useState<HorarioDATA>(
    {} as HorarioDATA,
  );

  const [pausaModal, setPausaModal] = useState(0);
  const [
    modalPausaProgramadaVisible,
    setModalPausaProgramadaVisible,
  ] = useState(false);
  const [
    modalPausaProgRemoveVisible,
    setModalPausaProgRemoveVisible,
  ] = useState(false);

  useEffect(() => {
    api
      .get('portal/horario/index')
      .then(response => {
        setHorarios(response.data.horarios);
        setSemana(response.data.semana);
        setParadas(response.data.paradas);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [company]);

  // UseEffect para bloquear a rolagem ao abrir algum modal
  useEffect(() => {
    if (modalHorariosVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [modalHorariosVisible]);

	const handleModal = useCallback((dia: any, horario: any) => { // useCallback((e, dia: any, horario: any) => {
    setDiaModal(dia);
    setHorarioModal(horario);
    setModalHorariosVisible(true);
  }, []);

  const handleDeletePausa = useCallback(async (id: any) => {
    await api
      .post('portal/pausa/store_delete', {
        id,
        title: '',
        comeca_em: '',
        termina_em: '',
      })
      .then(response => {
        setParadas(response.data.paradas);
        setModalPausaProgRemoveVisible(false);
      });
  }, []);

  return (
		<>
			<Container>
				<Sidebar />

				{loading ? (
					<Loading />
				) : (
					<Content>
						<Header>
							<h1>Horários de funcionamento.</h1>
							<h2>
								Escolha os dias e horários de funcionamento da sua loja.
							</h2>
						</Header>

						<TabsView>
							<Tabs className="tabs" index={tabIndex}>
								<TabList className="tab-list">
									<Tab className="tab" onClick={() => setTabIndex(0)}>
										Horarios
									</Tab>
									<Tab className="tab" onClick={() => setTabIndex(1)}>
										Pausa Programada
									</Tab>
								</TabList>

								<TabPanels className="tab-panels">
									<TabHorarios className="tab-panel">
										<Horario>
											<SemanaDias>
												<div className="indice">
													<div className="item-indice">
														<span>0h</span>
													</div>
													<div className="item-indice">
														<hr />
														<span>2h</span>
													</div>
													<div className="item-indice">
														<hr />
														<span>4h</span>
													</div>
													<div className="item-indice">
														<hr />
														<span>6h</span>
													</div>
													<div className="item-indice">
														<hr />
														<span>8h</span>
													</div>
													<div className="item-indice">
														<hr />
														<span>10h</span>
													</div>
													<div className="item-indice">
														<hr />
														<span>12h</span>
													</div>
													<div className="item-indice">
														<hr />
														<span>14h</span>
													</div>
													<div className="item-indice">
														<hr />
														<span>16h</span>
													</div>
													<div className="item-indice">
														<hr />
														<span>18h</span>
													</div>
													<div className="item-indice">
														<hr />
														<span>20h</span>
													</div>
													<div className="item-indice">
														<hr />
														<span>22h</span>
													</div>
													<div className="item-indice">
														<span>24h</span>
													</div>
												</div>

												{semana.map((dia, indice) => (
													<DiaSemana key={indice}>
														<h1>{dia.d_semana}</h1>
														<h2>Aberto por {dia.tempo}h</h2>

														<HorariosDia id="novo" dia={dia.dia}>
															<button
																onClick={() => permissions.alterar && handleModal(dia, {})}
																className="btn-oculto"
															></button>

															{horarios.map(
																(horario, ind) =>
																	horario.dia === dia.dia && (
																		<Periodo
																			id="periodo"
																			key={ind}
																			inicio={horario.inicio}
																			tempo={horario.tempo}
																			onClick={() => permissions.alterar && handleModal(dia, horario)}
																		>
																			<h3>
																				{horario.abertura}-{horario.fechamento}
																			</h3>
																		</Periodo>
																	)
															)}
														</HorariosDia>
													</DiaSemana>
												))}
											</SemanaDias>
										</Horario>
									</TabHorarios>

									<TabPausaProgramada className="tab-panel">
										{paradas.length > 0 ? (
											<ListPausas>
												<div className="header">
													<h2>
														Você pode cadastrar aqui os momentos em que a{' '}
														<br />
														loja estará fechada.
													</h2>

													{permissions.incluir && (
														<Button
															style={{ width: '30%', fontSize: '20px' }}
															onClick={() =>
																setModalPausaProgramadaVisible(true)
															}
														>
															Nova Pausa Programada
														</Button>
													)}
												</div>

												{paradas.map((item, indice) => (
													<ItemPausa key={indice}>
														<h1>{item.mes}</h1>

														{item.pausas.map((pausa, ind) => (
															<Pausa key={ind}>
																<div className="inicio">
																	<h1>{pausa.mot_event}</h1>
																	<h2>{pausa.tempo}</h2>
																	<h3>{pausa.valor}</h3>
																</div>

																<div className="fim">
																	<div className="comeca-termina">
																		<h1>{pausa.begin_event}</h1>
																		<h2>de {pausa.begin_hora}</h2>
																	</div>

																	<FiArrowRight />

																	<div className="comeca-termina">
																		<h1>{pausa.end_envent}</h1>
																		<h2>até {pausa.end_hora}</h2>
																	</div>

																	{permissions.excluir && (
																		<div className="btn-delete">
																			<button
																				onClick={() => {
																					setPausaModal(pausa.id_event);
																					setModalPausaProgRemoveVisible(true);
																				}}
																			>
																				<FiTrash2 />
																			</button>
																		</div>
																	)}
																</div>
															</Pausa>
														))}
													</ItemPausa>
												))}
											</ListPausas>
										) : (
											<NenhumaPausa>
												<GiTimeBomb />
												<h1>Nenhuma pausa cadastrada no momento.</h1>
												<h2>
													Aqui você pode cadastrar os momentos em que a loja
													permanecerá fechada
												</h2>

												{permissions.incluir && (
													<Button
														style={{ width: '30%', fontSize: '20px' }}
														onClick={() => setModalPausaProgramadaVisible(true)}
													>
														Cadastrar Pausa Programada
													</Button>
												)}
											</NenhumaPausa>
										)}
									</TabPausaProgramada>
								</TabPanels>
							</Tabs>
						</TabsView>
					</Content>
				)}
			</Container>

			{modalHorariosVisible && (
				<ModalHorarios
					onClose={() => setModalHorariosVisible(false)}
					isVisible={modalHorariosVisible}
					dia={diaModal}
					horario={horarioModal}
					setHorarios={setHorarios}
					setSemana={setSemana}
				/>
			)}

			{modalPausaProgramadaVisible && (
				<ModalPausaProgramada
					onClose={() => setModalPausaProgramadaVisible(false)}
					isVisible={modalPausaProgramadaVisible}
					setParadas={setParadas}
				/>
			)}

			{modalPausaProgRemoveVisible && (
				<ModalPausaProgRemove
					onClose={() => setModalPausaProgRemoveVisible(false)}
					isVisible={modalPausaProgRemoveVisible}
					id_pausa={pausaModal}
					handleDeletePausa={handleDeletePausa}
				/>
			)}
		</>
  );
};

export default Horarios;
